import MyTabs from '../../../components/MyTabs';
import GeographicalDetails from './GeographicalDetails';
import ArchitecturalLandmarks from './ArchitecturalLandmarks';
import OtherLandmarks from './OtherLandmarks';

const Introduction = (props) => {

    const tabs = [
        { id: "geographical-details", title: "Geographical Details", Component: GeographicalDetails },
        { id: "architectural-landmarks", title: "Architectural Landmarks", Component: ArchitecturalLandmarks },
        { id: "other-landmarks", title: "Other Landmarks", Component: OtherLandmarks },
    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default Introduction;